/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DummyMineablePunks,
  DummyMineablePunksInterface,
} from "../DummyMineablePunks";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punk",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "punkIdToAssets",
    outputs: [
      {
        internalType: "uint96",
        name: "",
        type: "uint96",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyMineablePunks__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyMineablePunks> {
    return super.deploy(overrides || {}) as Promise<DummyMineablePunks>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyMineablePunks {
    return super.attach(address) as DummyMineablePunks;
  }
  connect(signer: Signer): DummyMineablePunks__factory {
    return super.connect(signer) as DummyMineablePunks__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyMineablePunksInterface {
    return new utils.Interface(_abi) as DummyMineablePunksInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyMineablePunks {
    return new Contract(address, _abi, signerOrProvider) as DummyMineablePunks;
  }
}
